import cookie from 'js-cookie';
import cookieExists from './util/cookie_exists';

export const ALERT_BANNER_COOKIE = '__we_banner_cookie';
const DAYS_TO_EXPIRE = 60;

export function isAlertAcknowledged(alertId) {
  if (!cookieExists(ALERT_BANNER_COOKIE)) {
    return false;
  }
  const alertLookup = JSON.parse(cookie.get(ALERT_BANNER_COOKIE));
  return !!alertLookup[alertId];
}

function setAlertBannerCookie(value) {
  cookie.set(ALERT_BANNER_COOKIE, value, {
    expires: DAYS_TO_EXPIRE,
    sameSite: 'lax',
    path: '/' // Just to make sure a browser doesn't set it to something else by default
  });
}

export function createAlertBannerCookie() {
  setAlertBannerCookie('{}');
}

export function acknowledgeAlert(alertId) {
  try {
    // Bad things happen if we try to parse a cookie that doesn't exist
    if (!cookieExists(ALERT_BANNER_COOKIE)) {
      createAlertBannerCookie();
      return acknowledgeAlert(alertId);
    }
    // Cookie is stored as JSON object
    const currentCookie = cookie.get(ALERT_BANNER_COOKIE);
    const alertLookup = JSON.parse(currentCookie);
    if (!isAlertAcknowledged(alertId)) {
      alertLookup[alertId] = true;
      setAlertBannerCookie(JSON.stringify(alertLookup));
    }
  } catch (err) {
    console.log('Logging user banner acknowledgement failed. Check to see if cookie exists.', err); // eslint-disable-line
  }
}
